<template>
  <div
    v-if="isCookieBannerVisible"
    class="cookie-modal-overlay"
    :class="{ 'fade-in': !isClose }"
  >
    <div
      class="cookie-modal"
      :class="{ 'slide-up': !isClose, 'slide-down': isClose }"
    >
      <div class="modal-header">
        <div class="cookie-icon">🍪</div>
        <h2 class="modal-title">Cookies</h2>
      </div>
      <div class="modal-body">
        <p>
          We use cookies on our website to enhance your browsing experience,
          remembering your preferences, and recognizing return visits. By
          selecting <b>'Accept All'</b>, you agree to the utilization of ALL
          cookies. However, if you prefer not to consent to all cookies, you can
          adjust your settings or choose <b>'Reject All'</b>.
        </p>
        <p>
          <a
            class="cookie-page-link"
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
            >Cookie Policy</a
          >
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn reject-btn" @click="closeCookieToast(false)">
          <span>Reject All</span>
        </button>
        <button class="btn accept-btn" @click="closeCookieToast(true)">
          <span>Accept All</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      link: `/${localStorage.getItem("language") ?? "en"}/cookie`,
      isCookieBannerVisible: false,
      isClose: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.name === "Cookie_Page") {
          this.isCookieBannerVisible = false;
          document.body.style.overflow = "";
        } else {
          this.checkCookieVisibility();
          if (this.isCookieBannerVisible) {
            document.body.style.overflow = "hidden";
          }
        }
      },
    },
  },
  methods: {
    closeCookieToast(accept) {
      const expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() + 1);

      if (accept) {
        localStorage.setItem("is_Cookie_Accepted", "true");
      } else {
        localStorage.setItem("is_Cookie_rejected", "true");
      }
      localStorage.setItem(
        "cookie_choice_expire",
        expirationDate.toUTCString()
      );

      this.isClose = true;
      setTimeout(() => {
        this.isCookieBannerVisible = false;
        document.body.style.overflow = "";
      }, 500);
    },
    checkCookieVisibility() {
      const isAccepted = localStorage.getItem("is_Cookie_Accepted") === "true";
      const isRejected = localStorage.getItem("is_Cookie_rejected") === "true";
      const expirationDate = localStorage.getItem("cookie_choice_expire");

      if ((isAccepted || isRejected) && expirationDate) {
        if (new Date(expirationDate) > new Date()) {
          this.isCookieBannerVisible = false;
        } else {
          localStorage.removeItem("is_Cookie_Accepted");
          localStorage.removeItem("is_Cookie_rejected");
          localStorage.removeItem("cookie_choice_expire");
          localStorage.removeItem("__ga");
          this.isCookieBannerVisible = true;
        }
      } else {
        this.isCookieBannerVisible = true;
        document.body.style.overflow='hidden';
      }
    },
  },
};
</script>

<style scoped>
.cookie-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cookie-modal-overlay.fade-in {
  opacity: 1;
}

.cookie-modal {
  background: #0d1117;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transform: translateY(50px);
  opacity: 0;
  overflow: hidden;
}

.cookie-modal.slide-up {
  animation: slideUp 0.5s ease forwards;
}

.cookie-modal.slide-down {
  animation: slideDown 0.5s ease forwards;
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #0d1117;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.cookie-icon {
  font-size: 24px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.modal-body {
  padding: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #b8c2cc;
  background: #0d1117;
}

.cookie-page-link {
  color: #64b5f6;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.cookie-page-link:hover {
  color: #90caf9;
  text-decoration: underline;
}

.modal-footer {
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #0d1117;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.btn {
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0)
  );
  transition: all 0.3s ease;
}

.reject-btn {
  background: linear-gradient(145deg, #f44336, #d32f2f);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);
}

.reject-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4);
}

.accept-btn {
  background: linear-gradient(145deg, #4caf50, #388e3c);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.accept-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

@keyframes slideUp {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
  }
}

/* Dark mode enhancements */
@media (prefers-color-scheme: dark) {
  .cookie-modal {
    background: #0d1117;
  }

  .modal-body {
    color: #b8c2cc;
  }
}
</style>
